import { useFormik } from 'formik';
// mantine
import { Button, UnstyledButton } from '@mantine/core';
// components
import { IActor, TPersona } from '@newo/api/gateway';
import PersonasAutocomplete from '@/modules/Personas/components/PersonasAutocomplete';
import ActorCombobox from '@/modules/Personas/components/ActorCombobox';
// utils
import validationSchema from '@/modules/Analytics/components/Toolbar/components/SelectUserForm/SelectUserForm.schema.tsx';

interface SelectUserFormProps {
    persona?: TPersona;
    actor?: IActor;
    onClose: () => void;
    onSubmit: (persona?: TPersona, actor?: IActor) => void;
}

const SelectUserForm = ({
    persona,
    actor,
    onClose,
    onSubmit
}: SelectUserFormProps) => {
    const formik = useFormik({
        initialValues: {
            persona,
            actor
        },
        validationSchema,
        onSubmit(values) {
            onSubmit(values.persona, values.actor);
            onClose();
        }
    });

    const handleCancel = () => {
        onClose();
    };

    const handleSelect = async (selectedPersona?: TPersona) => {
        await formik.setFieldValue('actor', undefined);
        await formik.setFieldValue('persona', selectedPersona);
    };

    const handleActorChange = (selectedActorId?: string) => {
        formik.setFieldValue(
            'actor',
            formik.values.persona?.actors.find((a) => a.id === selectedActorId)
        );
    };

    return (
        <form
            autoComplete="off"
            className="flex flex-col gap-3"
            onSubmit={formik.handleSubmit}
        >
            <PersonasAutocomplete
                label="Select Persona"
                params={{ is_linked_to_agent: false }}
                personaName={persona?.name}
                placeholder="Start typing..."
                onSelectAsync={handleSelect}
            />

            <ActorCombobox
                actors={formik.values.persona?.actors ?? []}
                label="Select Actor"
                value={formik.values.actor?.id}
                onChange={handleActorChange}
            />

            <div className="flex justify-between gap-2">
                <UnstyledButton
                    className="text-xs text-gray-6"
                    onClick={handleCancel}
                >
                    Cancel
                </UnstyledButton>
                <Button
                    disabled={!formik.isValid || formik.isSubmitting}
                    size="xs"
                    type="submit"
                >
                    Save
                </Button>
            </div>
        </form>
    );
};

export default SelectUserForm;
